// IMPORTS
import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  getButtonCollapsedMemory,
  getMenuCollapsedMemory,
  setButtonCollapsedmemory,
  setMenuCollapsedmemory,
} from "../data/memory";
import { useWindowSize } from "../componets/useWindowSize";
import Menu from "../componets/Menu";
import AlertSuccess from "../componets/AlerSuccess";
import AlertError from "../componets/AlertError";
import AlertPerigo from "../componets/AlertPerigo";
import { getDatabase, ref, update, get } from "firebase/database";
import { resetList } from "../data/resetList";
import { autoResetJogosMensal } from "../data/autoClear";
import { deleteJogo } from "../data/deleteJogo";

const ConfiguracoesAdmin: React.FC = () => {
  const { width } = useWindowSize();
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(
    getMenuCollapsedMemory()
  );
  const [isButtonCollapsed, setIsButtonCollapsed] = useState(
    getButtonCollapsedMemory()
  );

  const [successAlert, setSuccessAlert] = useState({
    open: false,
    message: "",
  });
  const [errorAlert, setErrorAlert] = useState({ open: false, message: "" });

  const [allUsers, setAllUsers] = useState<{ uid: string; name: string }[]>([]);
  const [blockedUsers, setBlockedUsers] = useState<
    { uid: string; name: string }[]
  >([]);
  const [pendingApprovalUsers, setPendingApprovalUsers] = useState<
    { uid: string; name: string }[]
  >([]);
  const [selectedUser, setSelectedUser] = useState<string>("");
  const [totalJogos, setTotalJogos] = useState<number | null>(null);
  const [jogosAnual, setJogosAnual] = useState<number | null>(null);
  const [isBlocked, setIsBlocked] = useState<boolean>(false);

  const [isAnualModalOpen, setIsAnualModalOpen] = useState(false);
  const [isMensalModalOpen, setIsMensalModalOpen] = useState(false);
  const [isDeleteJogoModalOpen, setIsDeleteJogoModalOpen] = useState(false);

  useEffect(() => {
    resetList();
    autoResetJogosMensal();
  }, []);

  useEffect(() => {
    if (width < 1000) {
      setIsMenuCollapsed(true);
      setMenuCollapsedmemory(true);
    } else if (!getButtonCollapsedMemory()) {
      setIsMenuCollapsed(false);
      setMenuCollapsedmemory(false);
    }
  }, [width]);

  const handleMenuToggle = () => {
    const newState = !isButtonCollapsed;
    setIsButtonCollapsed(newState);
    setButtonCollapsedmemory(newState);
    setIsMenuCollapsed(newState);
    setMenuCollapsedmemory(newState);
  };

  useEffect(() => {
    const db = getDatabase();
    const usersRef = ref(db, "users");
    get(usersRef).then((snapshot) => {
      if (snapshot.exists()) {
        const usersData = snapshot.val();

        const userList = Object.keys(usersData)
          .filter((uid) => usersData[uid].level !== "dev")
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" })
          );

        const blockedList = Object.keys(usersData)
          .filter((uid) => usersData[uid].bloq === true)
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }));

        const pendingList = Object.keys(usersData)
          .filter(
            (uid) =>
              usersData[uid].bloq === true &&
              usersData[uid].solicitacaoReentrada === "pending"
          )
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }));

        setAllUsers(userList);
        setBlockedUsers(blockedList);
        setPendingApprovalUsers(pendingList);
      }
    });
  }, []);

  const fetchUsers = () => {
    const db = getDatabase();
    const usersRef = ref(db, "users");
    get(usersRef).then((snapshot) => {
      if (snapshot.exists()) {
        const usersData = snapshot.val();

        const userList = Object.keys(usersData)
          .filter((uid) => usersData[uid].level !== "dev")
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }))
          .sort((a, b) =>
            a.name.localeCompare(b.name, "pt-BR", { sensitivity: "base" })
          );

        const blockedList = Object.keys(usersData)
          .filter((uid) => usersData[uid].bloq === true)
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }));

        const pendingList = Object.keys(usersData)
          .filter(
            (uid) =>
              usersData[uid].bloq === true &&
              usersData[uid].solicitacaoReentrada === "pending"
          )
          .map((uid) => ({
            uid,
            name: usersData[uid].displayName || "Sem nome",
          }));

        setAllUsers(userList);
        setBlockedUsers(blockedList);
        setPendingApprovalUsers(pendingList);
      }
    });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const resetJogosAnual = async (uid?: string) => {
    const db = getDatabase();
    try {
      if (uid) {
        await update(ref(db, `users/${uid}`), { jogosAnual: 0 });
        setSuccessAlert({
          open: true,
          message: "Jogos anuais resetados para o usuário.",
        });
      } else {
        const snapshot = await get(ref(db, "users"));
        if (snapshot.exists()) {
          const updates: Record<string, any> = {};
          Object.keys(snapshot.val()).forEach((key) => {
            updates[`users/${key}/jogosAnual`] = 0;
          });
          await update(ref(db), updates);
          setSuccessAlert({
            open: true,
            message: "Jogos anuais resetados para todos.",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setErrorAlert({ open: true, message: "Erro ao resetar jogos anuais." });
    }
  };

  const resetJogosMensal = async (uid?: string) => {
    const db = getDatabase();
    try {
      if (uid) {
        await update(ref(db, `users/${uid}`), { totalJogos: 0 });
        setSuccessAlert({
          open: true,
          message: "Jogos mensais resetados para o usuário.",
        });
      } else {
        const snapshot = await get(ref(db, "users"));
        if (snapshot.exists()) {
          const updates: Record<string, any> = {};
          Object.keys(snapshot.val()).forEach((key) => {
            updates[`users/${key}/totalJogos`] = 0;
          });
          await update(ref(db), updates);
          setSuccessAlert({
            open: true,
            message: "Jogos mensais resetados para todos.",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setErrorAlert({ open: true, message: "Erro ao resetar jogos mensais." });
    }
  };

  const handleSelectUser = async (uid: string) => {
    setSelectedUser(uid);
    if (!uid) {
      setTotalJogos(null);
      setJogosAnual(null);
      setIsBlocked(false);
      return;
    }

    const db = getDatabase();
    const userRef = ref(db, `users/${uid}`);
    const snapshot = await get(userRef);
    if (snapshot.exists()) {
      const data = snapshot.val();
      setTotalJogos(data.totalJogos ?? 0);
      setJogosAnual(data.jogosAnual ?? 0);
      setIsBlocked(data.bloq ?? false);
    }
  };

  const handleSaveJogos = async () => {
    if (!selectedUser) return;
    const db = getDatabase();
    try {
      await update(ref(db, `users/${selectedUser}`), {
        totalJogos: totalJogos ?? 0,
        jogosAnual: jogosAnual ?? 0,
      });
      setSuccessAlert({
        open: true,
        message: "Valores atualizados com sucesso.",
      });
      setSelectedUser("");
      setTotalJogos(null);
      setJogosAnual(null);
      setIsBlocked(false);
    } catch (error) {
      console.error(error);
      setErrorAlert({ open: true, message: "Erro ao salvar os valores." });
    }
  };

  const deleteUserAccess = async () => {
    if (!selectedUser) return;
    const db = getDatabase();

    try {
      if (isBlocked) {
        setErrorAlert({
          open: true,
          message: "Essa usuária já está deletada.",
        });
        return;
      }

      const updates: Record<string, any> = {
        [`users/${selectedUser}/bloq`]: true,
        [`users/${selectedUser}/solicitacaoReentrada`]: "none",
        [`users/${selectedUser}/isTuesday`]: false,
        [`users/${selectedUser}/jogoContabilizado`]: false,
        [`users/${selectedUser}/penalidadeJogo`]: false,
        [`users/${selectedUser}/totalJogos`]: 0,
        [`users/${selectedUser}/jogosAnual`]: 0,
        [`users/${selectedUser}/aniversario`]: null,
        [`users/${selectedUser}/inscricao`]: null,
        [`presenca/${selectedUser}`]: null,
        [`presencahistorico/${selectedUser}`]: null,
        [`torneio/super/inscritos/${selectedUser}`]: null,
      };

      const historicoSnapshot = await get(ref(db, "historico"));
      if (historicoSnapshot.exists()) {
        const historico = historicoSnapshot.val();
        Object.entries(historico).forEach(([key, value]: [string, any]) => {
          if (value?.userId === selectedUser) {
            updates[`historico/${key}`] = null;
          }
        });
      }

      await update(ref(db), updates);

      setIsBlocked(true);
      fetchUsers();
      setSuccessAlert({
        open: true,
        message: "Usuária deletada e rastros limpos do banco.",
      });
    } catch (error) {
      console.error(error);
      setErrorAlert({
        open: true,
        message: "Erro ao deletar a usuária.",
      });
    }
  };

  const approveReentry = async (uid: string) => {
    const db = getDatabase();
    try {
      await update(ref(db, `users/${uid}`), {
        bloq: false,
        solicitacaoReentrada: "none",
      });
      fetchUsers();
      if (selectedUser === uid) {
        setIsBlocked(false);
      }
      setSuccessAlert({
        open: true,
        message: "Solicitação aprovada com sucesso.",
      });
    } catch (error) {
      console.error(error);
      setErrorAlert({
        open: true,
        message: "Erro ao aprovar solicitação.",
      });
    }
  };

  return (
    <main className="flex h-dvh bg-black">
      <AlertSuccess
        isOpen={successAlert.open}
        message={successAlert.message}
        onClose={() => setSuccessAlert({ open: false, message: "" })}
      />
      <AlertError
        isOpen={errorAlert.open}
        message={errorAlert.message}
        onClose={() => setErrorAlert({ open: false, message: "" })}
      />
      <AlertPerigo
        isOpen={isAnualModalOpen}
        onClose={() => setIsAnualModalOpen(false)}
        onConfirm={() => {
          resetJogosAnual(selectedUser || undefined);
          setIsAnualModalOpen(false);
        }}
        message="Você tem certeza que deseja resetar a contagem anual de jogos?"
      />
      <AlertPerigo
        isOpen={isMensalModalOpen}
        onClose={() => setIsMensalModalOpen(false)}
        onConfirm={() => {
          resetJogosMensal(selectedUser || undefined);
          setIsMensalModalOpen(false);
        }}
        message="Você tem certeza que deseja resetar a contagem mensal de jogos?"
      />
      <AlertPerigo
        isOpen={isDeleteJogoModalOpen}
        onClose={() => setIsDeleteJogoModalOpen(false)}
        onConfirm={async () => {
          try {
            await deleteJogo();
            setIsDeleteJogoModalOpen(false);
            setSuccessAlert({
              open: true,
              message: "Jogo cancelado com sucesso!",
            });
          } catch (error) {
            console.error("Erro ao cancelar jogo:", error);
            setErrorAlert({
              open: true,
              message: "Erro ao cancelar jogo.",
            });
          }
        }}
        message="Você tem certeza que deseja cancelar o jogo?"
      />

      <div
        className={`fixed top-0 left-0 flex h-full flex-col ${
          isMenuCollapsed ? "w-16" : "w-64"
        } bg-black text-white transition-all duration-300`}
      >
        <button className="p-4 text-white" onClick={handleMenuToggle}>
          {isMenuCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <div className="min-h-0 flex-1">
          <Menu isCollapsed={isMenuCollapsed} />
        </div>
      </div>

      <section
        className={`flex flex-col w-full h-full p-6 ${
          isMenuCollapsed ? "ml-16" : "ml-64"
        } transition-all duration-300 overflow-y-auto`}
      >
        <div className="flex flex-col items-center gap-10 py-12">
          <div className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg">
            <h1 className="text-xl font-bold text-white mb-4 text-center">
              Resetar Jogos
            </h1>

            <label className="text-white mb-2">
              Selecionar usuário (opcional)
            </label>
            <select
              value={selectedUser}
              onChange={(e) => handleSelectUser(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 text-white border border-gray-600"
            >
              <option value="">Todos os usuários</option>
              {allUsers.map((user) => (
                <option key={user.uid} value={user.uid}>
                  {user.name}
                </option>
              ))}
            </select>

            {selectedUser && (
              <div className="mt-4 space-y-3 text-white">
                <div>
                  <label className="block">Total de Jogos mensal:</label>
                  <input
                    type="number"
                    value={totalJogos ?? ""}
                    onChange={(e) => setTotalJogos(Number(e.target.value))}
                    className="w-full p-2 rounded-md bg-gray-800 border border-gray-600 text-white"
                  />
                </div>
                <div>
                  <label className="block">Jogos no Ano:</label>
                  <input
                    type="number"
                    value={jogosAnual ?? ""}
                    onChange={(e) => setJogosAnual(Number(e.target.value))}
                    className="w-full p-2 rounded-md bg-gray-800 border border-gray-600 text-white"
                  />
                </div>
                <button
                  onClick={handleSaveJogos}
                  className="w-full mt-4 p-2 bg-green-600 hover:bg-green-500 text-white font-bold rounded-md"
                >
                  Salvar valores
                </button>
                {isBlocked ? (
                  <div className="mt-2 rounded-md border border-white/10 bg-white/5 p-2 text-center text-sm text-zinc-300">
                    Usuária já deletada
                  </div>
                ) : (
                  <button
                    onClick={deleteUserAccess}
                    className="w-full mt-2 p-2 bg-red-600 hover:bg-red-500 text-white font-bold rounded-md"
                  >
                    Deletar Usuária
                  </button>
                )}
              </div>
            )}

            <button
              onClick={() => setIsAnualModalOpen(true)}
              className="mt-8 p-2 bg-pink-600 hover:bg-pink-500 text-white font-bold rounded-md"
            >
              Resetar contagem de jogos anual
            </button>

            <button
              onClick={() => setIsMensalModalOpen(true)}
              className="mt-4 p-2 bg-pink-600 hover:bg-pink-500 text-white font-bold rounded-md"
            >
              Resetar contagem de jogos mensal
            </button>
            <button
              onClick={() => setIsDeleteJogoModalOpen(true)}
              className="mt-4 p-2 bg-red-600 hover:bg-pink-500 text-white font-bold rounded-md"
            >
              Cancelar jogo do dia
            </button>
          </div>

          {pendingApprovalUsers.length > 0 && (
            <div className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg mt-8">
              <h2 className="text-lg font-bold text-white mb-4 text-center">
                Solicitações de reentrada
              </h2>
              <ul className="space-y-3 text-white">
                {pendingApprovalUsers.map((user) => (
                  <li
                    key={user.uid}
                    className="flex items-center justify-between gap-3 border-b border-gray-700 pb-3"
                  >
                    <span>{user.name}</span>
                    <button
                      onClick={() => approveReentry(user.uid)}
                      className="rounded-md bg-green-600 px-3 py-2 text-sm font-bold text-white hover:bg-green-500"
                    >
                      Aprovar
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Lista de usuários deletados */}
          <div className="flex flex-col w-full max-w-md p-6 rounded-2xl bg-gray-900 shadow-lg mt-8">
            <h2 className="text-lg font-bold text-white mb-4 text-center">
              Usuárias deletadas
            </h2>
            {blockedUsers.length === 0 ? (
              <p className="text-white text-center">
                Nenhuma usuária deletada.
              </p>
            ) : (
              <ul className="space-y-2 text-white">
                {blockedUsers.map((user) => (
                  <li key={user.uid} className="border-b border-gray-700 pb-2">
                    {user.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ConfiguracoesAdmin;
